var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiotimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_30652",
    "data-name": "Group 30652",
    width: 28,
    height: 19.052,
    viewBox: "0 0 28 19.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20973",
    "data-name": "Path 20973",
    d: "M0,6.639A6.64,6.64,0,0,1,11.807,2.47l-1.32,1.122a4.907,4.907,0,1,0-1.24,7.2,5.691,5.691,0,0,0,.882-.708,4.93,4.93,0,0,0,.5-.593l.008.006c.824-.979,1.721-2.134,2.755-3.464v0l.018-.023.047-.061,0,0c.773-.994,1.649-2.121,2.6-3.315a7.174,7.174,0,0,1,1.312-1.3,4.871,4.871,0,0,1,2.3-1.044l.1.861h-.289v.952a5.359,5.359,0,0,0-2.041,1.578c-.986,1.234-1.867,2.366-2.644,3.366l0,0-.015.02c-1.086,1.4-2.024,2.6-2.843,3.566L11.9,10.7a4.527,4.527,0,0,1-.531.607A6.623,6.623,0,0,1,7.683,13.2l-.028,0h0A6.645,6.645,0,0,1,0,6.639Z",
    transform: "translate(0 5.773)",
    fill: "#0e5b9d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20974",
    "data-name": "Path 20974",
    d: "M11.291,18.522a6.613,6.613,0,0,1-2.12-1.443l1.331-1.12a4.906,4.906,0,1,0,1.2-7.941L8.113,9.047l-.022-.008A6.679,6.679,0,0,1,13.268,5.8a6.064,6.064,0,0,0-11.592.465A6.6,6.6,0,0,0,0,5.824a7.8,7.8,0,0,1,15.1.058,6.64,6.64,0,1,1-3.809,12.64Zm2.8-12.746h0Zm-.037,0h0Zm-.038,0h0Zm-.039,0h0Zm-.079,0h0Z",
    transform: "translate(7.467)",
    fill: "#0e5b9d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20966",
    "data-name": "Path 20966",
    d: "M17.742,50.907,15,48.6l2.6.866L20.485,46Z",
    transform: "translate(-10.67 -36.747)",
    fill: "#fc4c02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiotimeIcon);
export default __webpack_public_path__ + "static/media/biotime-icon.98299b66d2b86850eaa36a7e7b148eae.svg";
export { ForwardRef as ReactComponent };